import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import '../../../assets/css/general/NavigationBar.css';

const NavigationBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  // Button click handlers
  const handleDonorClick = () => {
    navigate('/donor');
    closeMenu();
  };

  const handleReceiverClick = () => {
    navigate('/receiver');
    closeMenu();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* Logo */}
        <div className="brand-logo">
          <Link to="/">
            <h1 className="nav-logo-text">SDMS</h1>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigation Items */}
        <div className={`nav-items-wrapper ${isMenuOpen ? 'active' : ''}`}>

          <Link to="/" className="nav-item-link" onClick={closeMenu}>
            Home
          </Link>

          {/* LISTINGS */}
          <div className="nav-item-dropdown">
            <button
              className="nav-item-link dropdown-trigger"
              onClick={() => toggleDropdown('listings')}
            >
              <Link to="/listings" className="nav-item-link">
                Listings
              </Link>
            </button>
          </div>

          {/* CONTACT */}
          <div className="nav-item-dropdown">
            <button
              className="nav-item-link dropdown-trigger"
              onClick={() => toggleDropdown('contact')}
            >
              <Link to="/Contact" className="nav-item-link">
                Contact
              </Link>
            </button>
          </div>

          {/* ABOUT */}
          <div className="nav-item-dropdown">
            <button
              className="nav-item-link dropdown-trigger"
              onClick={() => toggleDropdown('about')}
            >
              <Link to="/About" className="nav-item-link">
                About
              </Link>
            </button>

            {/* <div className={`dropdown-content ${activeDropdown === 'about' ? 'show' : ''}`}>
              <Link to="/about" onClick={closeMenu}>About Us</Link>
              <Link to="/about/team" onClick={closeMenu}>Our Team</Link>
              <Link to="/about/mission" onClick={closeMenu}>Our Mission</Link>
              <Link to="/about/testimonials" onClick={closeMenu}>Testimonials</Link>
              <div className="dropdown-divider"></div>
              <Link to="/careers" onClick={closeMenu}>Careers</Link>
            </div> */}
          </div>
        </div>

        {/* Right Side Actions */}
        <div className="navbar-actions">
          <button 
            className="first-action-btn donor-btn"
            onClick={handleDonorClick}
          >
            
           <Link to="/Doner"className="login-item-link">
                Donor
              </Link>
            
          
          </button>
          <button 
            className="first-action-btn receiver-btn"
            onClick={handleReceiverClick}
          >
            <Link to="/r-itemeceiver"className="Dlogin-item-link">
                Receiver
              </Link>
          </button>
        </div>

      </div>
    </nav>
  );
};

export default NavigationBar;